module.exports = __webpack_public_path__ + "static/media/logo.f29ac816.png";